<template>
  <div class="links-ctn">
    <router-link class="link" :to="{ name: 'modern-slavery-lang', params: { lang: currentLocale } }">
      {{ $t('footer.modernSlavery') }}
    </router-link>
    <router-link
      class="link"
      :to="{ name: 'green-politic-lang', params: { lang: currentLocale } }"
    >
      {{ $t('footer.greenPolitic') }}
    </router-link>
    <router-link
      class="link"
      :to="{ name: 'anti-corruption-lang', params: { lang: currentLocale } }"
    >
      {{ $t('footer.antiCorruption') }}
    </router-link>
    <router-link
      class="link"
      :to="{ name: 'general-politic-lang', params: { lang: currentLocale } }"
    >
      {{ $t('footer.generalPolitic') }}
    </router-link>
    <router-link
      class="link"
      :to="{ name: 'legal-advice-lang', params: { lang: currentLocale } }"
    >
      {{ $t('footer.legalAdvice') }}
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'FooterLinks',
  computed: {
    currentLocale () {
      return this.$i18n.locale
    }
  },
  methods: {
    goTo (routeName) {
      this.$router.push({
        name: routeName,
        params: {
          lang: this.currentLocale
        }
      })
    }
  }
}
</script>

<style scoped lang="sass">
@tailwind utilities

.links-ctn
  @apply flex flex-col bg-grey text-center py-1 -mb-3 -mx-3
  @screen sm-l
    @apply -mx-5
  @screen lg
    @apply flex-row justify-center

.link
  @apply uppercase text-white text-xs font-bold no-underline cursor-pointer my-1
  @screen lg
    @apply my-0 mx-1
</style>
